import React from "react";
import { DefaultMenuDrawer } from "./DefaultMenu";

export default React.memo(DefaultMenuDrawer);
